/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetEnvironmentReleasePathParams = NonNullable<
  operations['internalGetEnvironmentRelease']['parameters']['path']
>;

export type InternalGetEnvironmentReleaseQueryParams = NonNullable<
  operations['internalGetEnvironmentRelease']['parameters']['query']
>;

export interface Input extends InternalGetEnvironmentReleasePathParams {
  apiVersion?: string;
  query?: InternalGetEnvironmentReleaseQueryParams;
}

export async function internalGetEnvironmentRelease(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/releases/{releaseId}',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
